import React from "react";
import { motion } from "framer-motion";

const Question = ({ question, options = [], correctAnswer, handleAnswer, selectedAnswer }) => {
  if (!question || options.length === 0) {
    return <p style={{ textAlign: "center", fontSize: "1.2rem", color: "#666" }}>Carregando pergunta...</p>;
  }

  const getOptionStyle = (option) => {
    if (!selectedAnswer) return { backgroundColor: "white", color: "#333", border: "2px solid #ddd" };

    if (option === correctAnswer) {
      return { backgroundColor: "#4CAF50", color: "white", border: "2px solid #388E3C" }; // Verde para resposta correta
    }

    if (option === selectedAnswer) {
      return { backgroundColor: "#D32F2F", color: "white", border: "2px solid #B71C1C" }; // Vermelho para errada escolhida
    }

    return { backgroundColor: "white", color: "#333", border: "2px solid #ddd" };
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        padding: "25px",
        borderRadius: "12px",
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
        textAlign: "center",
        width: "100%",
        maxWidth: "600px",
        margin: "0 auto", // Centraliza o componente
        boxSizing: "border-box", // Garante que padding e margin não afete o layout
      }}
    >
      <h2 style={{
        fontSize: "1.7rem", 
        color: "#D32F2F", 
        marginBottom: "20px", 
        wordBreak: "break-word", // Quebra a palavra se necessário em telas pequenas
      }}>
        {question}
      </h2>
      <div style={{ 
        display: "grid", 
        gap: "10px", 
        justifyContent: "center", 
        gridTemplateColumns: "1fr", // Uma coluna para facilitar em telas pequenas
        paddingBottom: "20px", // Espaço extra para não ficar apertado
      }}>
        {options.map((option, index) => (
          <motion.button
            key={index}
            onClick={() => handleAnswer(option)}
            style={{
              padding: "14px",
              fontSize: "1.1rem",
              borderRadius: "8px",
              cursor: selectedAnswer ? "not-allowed" : "pointer",
              fontWeight: "bold",
              textTransform: "uppercase",
              transition: "0.3s",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              ...getOptionStyle(option),
              width: "100%", // Garante que os botões ocupem toda a largura disponível
            }}
            disabled={!!selectedAnswer}
            aria-disabled={!!selectedAnswer}
            whileHover={{ scale: selectedAnswer ? 1 : 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {option}
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default Question;
